import { HttpClient, HttpParams, HttpParameterCodec } from '@angular/common/http';
import { inject } from '@angular/core';
import {User} from "../DcoApi/Client/RestClient"
export class dhl_address_api
{


  private http = inject(HttpClient);
  search(search: string): Promise<address[]> {
    return new Promise<address[]>(async (res, rej) => {


      this.http.get<address[]>(`/Backend/Api/V2/VersandAddressen/Suche?Querry=${search}`, { headers:{ 'Authorization' : "Bearer " + await User.Token } }).subscribe({
        next: (config) => {
          res(config);
        },
        error: (err) => {
          res([]);
        },
      });
    });
  }
}



export interface address  {
  straße: string;
  hausnummer: string;
  ort: string;
  plz: string;
}
